import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homecoverage',
  templateUrl: './homecoverage.component.html',
  styleUrls: ['./homecoverage.component.css']
})
export class HomecoverageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
